import { render } from "./UserReviewDropdown.vue?vue&type=template&id=00da21d6"
import script from "./UserReviewDropdown.vue?vue&type=script&lang=js"
export * from "./UserReviewDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__